import { render, staticRenderFns } from "./repository-detail.vue?vue&type=template&id=eb4a27c2&"
import script from "./repository-detail.vue?vue&type=script&lang=js&"
export * from "./repository-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports